import { useState, useEffect, useCallback } from 'react';

export function useTourTarget(targetSelector: string | null): DOMRect | null {
  const [rect, setRect] = useState<DOMRect | null>(null);

  const updateRect = useCallback(() => {
    if (!targetSelector) {
      setRect(null);
      return;
    }
    const el = document.querySelector(`[data-tour="${targetSelector}"]`);
    if (el) {
      setRect(el.getBoundingClientRect());
    } else {
      setRect(null);
    }
  }, [targetSelector]);

  useEffect(() => {
    updateRect();

    // Re-calc on scroll/resize
    const handleScroll = () => updateRect();
    const handleResize = () => updateRect();

    window.addEventListener('scroll', handleScroll, true);
    window.addEventListener('resize', handleResize);

    // Also observe DOM mutations in case element renders late
    const observer = new MutationObserver(() => {
      if (targetSelector && !document.querySelector(`[data-tour="${targetSelector}"]`)) return;
      updateRect();
    });
    observer.observe(document.body, { childList: true, subtree: true });

    return () => {
      window.removeEventListener('scroll', handleScroll, true);
      window.removeEventListener('resize', handleResize);
      observer.disconnect();
    };
  }, [targetSelector, updateRect]);

  return rect;
}
